const initialState = {
   current: {},
   isNotificationInProgress: true,
   notificationsList: [],
   notificationsStats: { total: 0, unread: 0, read: 0, by_type: {} },
   isNotificationsListLoading: true,
   isMarkReadInProgress: false,
};

export default initialState;
